import React from 'react';

const AboutPage: React.FC = () => (
  <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex flex-col">
    <div className="max-w-4xl mx-auto flex-1 flex flex-col justify-center items-center py-12 px-4">
      <h1 className="font-playfair text-4xl font-bold text-primary-600 mb-6">About Us</h1>
      <p className="font-poppins text-gray-600 text-lg mb-6 text-center max-w-2xl">
        Content Repurposer is built to empower creators to do more with their content. Learn about our mission and team.
      </p>
      {/* Add about/team info here */}
    </div>
  </div>
);

export default AboutPage;
